import { Organisation } from 'src/app/service/organisation/organisation';

import { Aufgabe } from './aufgabe';

export class Zuweisung {
    id: number;
    ersteller: Organisation;
    zugewiesen: Organisation;
    gelesen: boolean;
    aufgabe: Aufgabe;
    dokumentVorhanden: boolean;
    replyFileName: string;
    downloading: boolean;
}
